import { useParams } from 'react-router-dom';

import { useAppSelector } from 'app/hooks';
import { MembershipDeleteDialogContent } from 'common/components/deleteDialog/MembershipDeleteDialogContent';
import { selectPageInfo } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { FetchRoleDetailsResponse } from 'common/services/api/Roles/Roles.thunk';
import { deleteRoleUserMembership } from 'common/services/api/RoleUserMembership/RoleUserMembership.thunk';
import { DeleteDialogContentProps } from 'common/types/TypeDefs';

import { selectFilters } from './roleUserMembershipSlice';

type RoleUserRow = { firstName: string; lastName: string; userId: string };

export function RoleUserMembershipDeleteDialogContent({
    itemId,
    editingRow,
    paginationInfo,
    customDeleteTitle,
}: Readonly<DeleteDialogContentProps<RoleUserRow>>) {
    const { firstName, lastName, userId } = editingRow ?? {};
    const { tenantId, roleId } = useParams();
    const pageInfo = useAppSelector(selectPageInfo) as FetchRoleDetailsResponse;

    return (
        <MembershipDeleteDialogContent<RoleUserRow, Parameters<typeof deleteRoleUserMembership>[0]>
            itemId={itemId}
            editingRow={editingRow}
            paginationInfo={paginationInfo}
            customDeleteTitle={customDeleteTitle}
            deleteThunk={deleteRoleUserMembership}
            entityName="User from Role"
            successMessage="User has been removed from this Role under this Tenant."
            conflictMessage="The User link has child objects which need to be removed prior to deleting the User link."
            selectFilters={selectFilters}
            infoItems={[
                { label: 'User', value: `${firstName} ${lastName}` },
                { label: 'Role Name', value: pageInfo?.name },
                { label: 'Tenant Name', value: pageInfo?.tenantName },
            ]}
            buildDeleteParams={({ skip, take, search, sortModel, statusKeys }) => ({
                tenantId: tenantId ?? '',
                roleId: roleId ?? '',
                userId: userId ?? '',
                skip,
                take,
                search,
                sortModel,
                status: statusKeys,
            })}
        />
    );
}
